// API base: same-origin in every environment (preview, production, www/non-www) so auth
// cookies are always first-party. Falls back to the env var during build-time/SSR contexts.
export const API = `${typeof window !== "undefined" ? window.location.origin : process.env.REACT_APP_BACKEND_URL}/api`;
export const EASE = [0.16, 1, 0.3, 1];

// Welcome-section video — fallback if the office hasn't picked one in the dashboard video library.
export const WELCOME_VIDEO = {
  video_url: "/api/photos/bethel-center/videos/welcome-full.mp4",
  bg_url: "/api/photos/bethel-center/videos/welcome-bg.webm",
  poster_url: "/api/photos/bethel-center/videos/welcome-poster.jpg",
  title: "Welcome to Beth El Center for Jewish Life",
};

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
